module.exports = __webpack_public_path__ + "img/master card-01.a39e14ab.svg";